import Loader from '@/components/Loader';
import Details from '@/contacts/details/Details';
import { call } from '@/lib/api';
import { useBreadcrumbs } from '@/lib/breadcrumbs';
import { TContact } from '@/models/contacts';
import { DocumentGroups } from '@/types';
import { Paper, Tabs } from '@mantine/core';
import { useEffect, useState } from 'react';
import { PiAddressBook, PiFiles } from 'react-icons/pi';
import { useParams } from 'wouter';
import DocumentManager from '../DocumentManager/DocumentManager';

export default function Company() {
  const { id } = useParams();
  const [company, setContact] = useState<TContact | null>(null);
  const { setBreadcrumbs } = useBreadcrumbs();
  useEffect(() => {
    if (!id) return;
    const controller = new AbortController();
    const { signal } = controller;
    // eslint-disable-next-line react-hooks/set-state-in-effect -- clears stale data while the new id loads
    setContact(null);
    call<TContact>('monday/company', { signal, json: { pulseId: id } })
      .then((res) => res.json())
      .then(setContact)
      .catch((e) => {
        if (e !== 'changed') {
          throw e;
        }
      });
    return () => {
      controller.abort('changed');
    };
  }, [id]);

  useEffect(() => {
    if (!company) {
      return;
    }
    setBreadcrumbs([
      {
        title: 'Companies',
        to: '/companies',
      },
      {
        title: company.name,
        to: `/companies/${id}`,
      },
    ]);
    return () => {
      setBreadcrumbs([]);
    };
  }, [company, id, setBreadcrumbs]);

  if (!company) {
    return <Loader />;
  }

  return (
    <Paper p="md" maw="1000">
      <Tabs defaultValue="details" keepMounted={false}>
        <Tabs.List>
          <Tabs.Tab value="details" leftSection={<PiAddressBook />}>
            Details
          </Tabs.Tab>
          <Tabs.Tab value="documents" leftSection={<PiFiles />}>
            Documents
          </Tabs.Tab>
        </Tabs.List>
        <Tabs.Panel value="details">
          <Details contact={company} showPortalAccess={false} />
        </Tabs.Panel>
        <Tabs.Panel value="documents">
          <DocumentManager
            my="md"
            pulseId={company.id}
            groups={[
              DocumentGroups.CompanyDocuments,
              DocumentGroups.AdditionalDocuments,
            ]}
          />
        </Tabs.Panel>
      </Tabs>
    </Paper>
  );
}
